import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { MotionConfig } from "framer-motion";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import LegalCenter from "@/pages/LegalCenter";
import LegalDoc from "@/pages/LegalDoc";
import ManageData from "@/pages/ManageData";
import AdminLayout from "@/admin/AdminLayout";
import AdminLogin from "@/admin/Login";
import Dashboard from "@/admin/Dashboard";
import AdminUsers from "@/admin/Users";
import AdminConvoys from "@/admin/Convoys";
import AdminClubs from "@/admin/Clubs";
import AdminMembership from "@/admin/Membership";
import AdminSupport from "@/admin/Support";
import LiveMap from "@/admin/LiveMap";

const ScrollManager = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.__lenis?.scrollTo(0, { immediate: true });
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ autoRaf: true, lerp: 0.09 });
    window.__lenis = lenis;
    return () => {
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <MotionConfig reducedMotion="user">
      <div className="App grain">
        <BrowserRouter>
          <ScrollManager />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/legal" element={<LegalCenter />} />
            <Route path="/legal/:slug" element={<LegalDoc />} />
            <Route path="/manage-data" element={<ManageData />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<Dashboard />} />
              <Route path="users" element={<AdminUsers />} />
              <Route path="convoys" element={<AdminConvoys />} />
              <Route path="clubs" element={<AdminClubs />} />
              <Route path="membership" element={<AdminMembership />} />
              <Route path="support" element={<AdminSupport />} />
              <Route path="map" element={<LiveMap />} />
            </Route>
            <Route path="*" element={<Landing />} />
          </Routes>
          <Toaster theme="dark" position="top-center" richColors />
        </BrowserRouter>
      </div>
    </MotionConfig>
  );
}

export default App;
